import { RootState as RS } from "../types";
import { ImpersonationSlice } from "./reducer";

export const getImpersonationSlice = (s: RS): ImpersonationSlice =>
  s.impersonation;

export const getIsImpersonationFetching = (s: RS) =>
  getImpersonationSlice(s).isFetching;

export const getIsImpersonationSubmitting = (s: RS) =>
  getImpersonationSlice(s).isSubmitting;

export const getIsImpersonating = (s: RS) =>
  getImpersonationSlice(s).isImpersonating;

export const getImpersonatedUser = (s: RS) =>
  getImpersonationSlice(s).impersonatedUser;

export const getImpersonatedUserId = (s: RS) => getImpersonatedUser(s)?.id;

export const getImpersonatedUserName = (s: RS) =>
  getImpersonatedUser(s)?.userName;
